export default __webpack_public_path__ + "static/media/auteuil14.4cdb5b96.jpg";